import { ACTIVE_SERVER_ID } from 'mk/settings';
import {
    PHONE_VERIFICATION_GO_TO, PHONE_VERIFICATION_RESET, PHONE_VERIFICATION_SEND_SMS_FAILURE,
    PHONE_VERIFICATION_SEND_SMS_REQUEST,
    PHONE_VERIFICATION_SEND_SMS_SUCCESS,
    PhoneVerificationGoToAction, PhoneVerificationResetAction, PhoneVerificationSendSmsFailureAction,
    PhoneVerificationSendSmsRequestAction,
    PhoneVerificationSendSmsSuccessAction,
} from 'mk2/containers/PhoneVerification/PhoneVerification.actions';

export interface PhoneVerificationState {
    step: number;
    prefix: string;
    phoneNumber: string;
    limitReached: boolean;
    sending: boolean;
}

const initialState = {
    step: 1,
    prefix: ACTIVE_SERVER_ID === 201 ? '+421' : '+420',
    phoneNumber: '',
    limitReached: false,
    sending: false,
};

type PhoneVerificationActions = PhoneVerificationGoToAction
    | PhoneVerificationResetAction
    | PhoneVerificationSendSmsRequestAction
    | PhoneVerificationSendSmsSuccessAction
    | PhoneVerificationSendSmsFailureAction;

const reducer = (state: PhoneVerificationState = initialState, action: PhoneVerificationActions) => {
    switch (action.type) {
        case PHONE_VERIFICATION_GO_TO:
            return {
                ...state,
                step: action.step,
            };
        case PHONE_VERIFICATION_SEND_SMS_REQUEST:
            return {
                ...state,
                sending: true,
            };
        case PHONE_VERIFICATION_SEND_SMS_SUCCESS:
            return {
                ...state,
                prefix: action.response.prefix,
                phoneNumber: action.response.phoneNumber,
                sending: false,
            };
        case PHONE_VERIFICATION_SEND_SMS_FAILURE:
            return {
                ...state,
                limitReached: action.limitReached,
                sending: false,
            };
        case PHONE_VERIFICATION_RESET:
            return initialState;
        default:
            return state;
    }
};

export default reducer;

export const getStep = (state: PhoneVerificationState) => state.step;
export const getPrefix = (state: PhoneVerificationState) => state.prefix;
export const getPhoneNumber = (state: PhoneVerificationState) => state.phoneNumber;
export const getLimitReached = (state: PhoneVerificationState) => state.limitReached;
export const getSending = (state: PhoneVerificationState) => state.sending;
